<ng-container *transloco="let t">
  <app-page-template [showBreadcrumbs]="false">
    <ng-template [ngTemplateOutlet]="carousel"></ng-template>
    <ng-template [ngTemplateOutlet]="searchFrom"></ng-template>
    @if (eventMapVisible) {
      <ng-template [ngTemplateOutlet]="eventMap"></ng-template>
    } @else {
      <ng-template [ngTemplateOutlet]="eventList"></ng-template>
    }
    <app-footer/>
  </app-page-template>

  <ng-template #carousel>
    <app-carousel [images]="[images[0]]" bannerImage="assets/img/cpr_transparent.png" alt="We trace you race">
      <div slot="content">
        @if (this.calendarType === EventItemType.UPCOMING) {
          @if (eventMapVisible) {
            <div class="carousel-button" (click)="toggleEventMapVisible()">
              {{ t("event.calendar.show.eventCalendar") }}
            </div>
          } @else {
            <div class="carousel-button" (click)="toggleEventMapVisible()">
              {{ t("event.calendar.show.map") }}
            </div>
          }
        }
      </div>
    </app-carousel>
  </ng-template>

  <ng-template #searchFrom>
    <div
      class="px-0 px-md-5 d-flex flex-column flex-md-row justify-content-center align-items-baseline align-items-lg-center filter-box mb-4">
      <div class="ps-2 pe-2 pe-md-4 px-md-0 me-0 me-md-3 search-wrapper">
        <app-search [searchBarClass]="'extra-small'" (searchQuery)="handleInput($event)" [inputValue]="name"
                    [placeholder]="t('search.placeholder.races')"/>
      </div>
      <form #filterRacesForm="ngForm" class="filter-form">
        <div class="explore-filter__grid">
          <div class="explore-filter__grid-inner">
            <div class="d-flex">
              <div class="ms-2 ms-md-0 flex-grow-1 flex-lg-grow-0">
                <app-date-range-selector (dateChanged)="dateChanged($event)"
                                         [maxDate]="calendarType === EventItemType.FINISHED ? initialDate: undefined"
                                         [minDate]="calendarType === EventItemType.UPCOMING ? initialDate : undefined"
                                         [toDate]="dateTo"
                                         [fromDate]="dateFrom"/>
              </div>
              <div class="ms-2 me-2 flex-grow-1 flex-lg-grow-0">
                <div ngbDropdown class="dropdown-small" container="body">
                  <div class="dropdown" id="raceLengthDropdown" ngbDropdownToggle>
                    {{ selectedLength ? selectedLength : t("explore.races.length") }}
                  </div>
                  <div ngbDropdownMenu aria-labelledby="raceLengthDropdown">
                    <button ngbDropdownItem (click)="onLengthSelect()">{{ t("app.common.all") }}
                      @if (selectedLength === undefined) {
                        <i class="bi bi-check"></i>
                      }
                    </button>
                    @for (length of lengths;track length) {
                      <button ngbDropdownItem (click)="onLengthSelect(length)">
                        {{ length + " " + environment.lengthDropdownMeasurementUnit }}
                        @if (selectedLength === length) {
                          <i class="bi bi-check"></i>
                        }
                      </button>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div class="position-relative pe-2 ps-2">
              <div ngbDropdown class="dropdown-small" container="body">
                <div class="dropdown" id="sportsDropdown" ngbDropdownToggle>
                  {{ sportId ? t('app.common.sports.' + sportId) : t("explore.sports") }}
                </div>
                <div ngbDropdownMenu aria-labelledby="raceLengthDropdown">
                  <button ngbDropdownItem (click)="onSportSelect()">{{ t("app.common.all") }}
                    @if (sportId === undefined) {
                      <i class="bi bi-check"></i>
                    }
                  </button>
                  @for (sport of sports;track sport) {
                    <button ngbDropdownItem (click)="onSportSelect(sport.id)">
                      {{ t('app.common.sports.' + sport.id) }}
                      @if (sportId === sport.id) {
                        <i class="bi bi-check"></i>
                      }
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </ng-template>

  <ng-template #eventList>
    <div class="padding-bottom-92">
      <section class="next-race-section upper-section-background">
        <div class="container">
          <app-loader [isLoading]="isLoading"></app-loader>
          <section>
            @if (listOfEvents.length ?? 0 > 0) {
              <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3">
                @for (item of listOfEvents;track trackByFn) {
                  <div class="col mb-4">
                    <app-event-grid-item-with-image (click)="goToEventDetailsPage(item)" [eventItem]="item"
                                                    [countries]="countries"
                                                    [isFinishedEvent]="this.calendarType === EventItemType.FINISHED"
                                                    [languages]="languages" [favoriteItems]="favoriteItems"/>
                  </div>
                }
              </div>
            } @else {
              <app-empty-state/>
            }
            @if ((listOfEvents.length ?? 0 > 0) && hasMoreEvents) {
              <div class="d-flex justify-content-center load-more-wrapper">
                <app-rounded-button [label]="t('app.common.load.more.races')"
                                    (onClick)="loadMore()"/>
              </div>
            }
          </section>
        </div>
      </section>
      @if ((listOfEvents.length ?? 0 > 0) && showFabButton) {
        <div (click)="scrollToTop()" class="scroll-to-top">
          <i class="bi bi-arrow-up"></i>
        </div>
      }
    </div>
  </ng-template>

  <ng-template #eventMap>
    <div>
      <section class="pb-300-228">
        <div class="container">
          <app-loader [isLoading]="isLoading"></app-loader>
          <section>
            <app-leaflet-maps-wrapper [lat]="lat" [lng]="lng" [points]="waypointList" [languages]="languages"
                              [countries]="countries" [mapOnEventCalendar]="true" [increaseMapHeight]="true"/>
          </section>
        </div>
      </section>
    </div>
  </ng-template>
</ng-container>
